import { render, staticRenderFns } from "./CreateTollGroup.vue?vue&type=template&id=40092799"
import script from "./CreateTollGroup.vue?vue&type=script&lang=js"
export * from "./CreateTollGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports